import { Component, OnInit } from '@angular/core';

import { Input, Output, EventEmitter } from '@angular/core';

import { FormGroup, FormControl } from '@angular/forms';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';

import * as sha1 from 'js-sha1';


const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

interface UserInput {
    iduser: number;
    prenom: string;
} ;



@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.css']
})
export class AuthentificationComponent implements OnInit {

   login = "" ;
   pwd = "" ;

   mustChangepwd = 0 ;
   nwpwd = "" ;
   nwpwdconfirmed = "" ;

   erreurLogin = 0 ;
   erreurCoher = 0 ;

   fdg : any ; 
  canOnlyPrepay = false ;

  ROUTES = [] ;


  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
  }


  farLogin(){    
    let logdata = {login: this.login , pwd: sha1(this.pwd) } ;  
    // Code to deCommente for dev purposes under airplane mode (no network)
    //this.router.navigate(['/homecpnt']) ;
    this.remotelogger('https://admindjolof.sentelecom.com/assurance/courtier/yeurrlouBO.php', logdata ).subscribe(
      retourPost => {

        if (retourPost["statutreq"]!=undefined && retourPost["statutreq"]==1){
          this.erreurLogin = 0 ;

          sessionStorage.setItem("profil", retourPost["data"].profil.toString()) ;
          sessionStorage.setItem("compliances", retourPost["data"].compliances) ;
          sessionStorage.setItem("samacaabiyoonwii", retourPost["data"].token.toString()) ;

          if (retourPost["data"].firstuse!=1){
           let usrInfos = retourPost ;
           this.diottCiYoonYimaSagnaDieul( retourPost["data"].profil.toString(), retourPost["data"].compliances);
           this.router.navigate([ this.ROUTES[0].path ]) ;
          }else{
            this.mustChangepwd = 1 ;
            this.fdg = retourPost["data"].profil ;
          }
        }
        else{
          console.log("FAILED: ", retourPost) ;
          this.erreurLogin = 1 ;
        }
    } ) ;             
  }

  isOnlyPrepaidAuthorized(compliances){
    let allOfThem = JSON.parse(compliances) ;
    this.canOnlyPrepay = false ;
    for (var i = 0; i < allOfThem.length; i++) {
        if(allOfThem[i].name=="solde_impaye")
            this.canOnlyPrepay = Number(allOfThem[i].valeur)<=0 ;
    }
  }


  diottCiYoonYimaSagnaDieul(profil, compliances){
    console.log("Profil: ", profil);

    //let compliances = sessionStorage.getItem("compliances") ;
    if(profil=="ADMINISTRATEUR"){
      this.ROUTES = [
            // rapportfin
            { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
            { path: '/homecpnt/sousreseau', title: 'Réseau',  icon:'person', class: '' },
            { path: '/homecpnt/rapportfin', title: 'Situation',  icon:'library_books', class: '' },
            { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
            { path: '/homecpnt/crm', title: 'CRM',  icon:'folder', class: '' },
            { path: '/homecpnt/partners', title: 'Partenaires',  icon: 'toc', class: '' },
            { path: '/homecpnt/packaging', title: 'Packaging',  icon:'view_column', class: '' },
            { path: '/homecpnt/comptafinances', title: 'Compta-Finances',  icon: 'money', class: '' },
            { path: '/homecpnt/avenants', title: 'Avenants',  icon:'settings', class: '' },
            { path: '/homecpnt/parametrage', title: 'Paramètrage',  icon:'settings', class: '' },
      ] ;
    }
                
    if(profil=="ADMINISTRATEUR DJOLOF"){
      this.ROUTES = [
            // rapportfin
            { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
            { path: '/homecpnt/sousreseau', title: 'Réseau',  icon:'person', class: '' },
            { path: '/homecpnt/rapportfin', title: 'Situation',  icon:'library_books', class: '' },
/*            { path: '/homecpnt/partners', title: 'Partenaires',  icon: 'toc', class: '' },*/
            { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
            { path: '/homecpnt/crm', title: 'CRM',  icon:'folder', class: '' }
      ] ;
    }

    sessionStorage.setItem("yoonyifiam", JSON.stringify(this.ROUTES)) ;


  }



  updatePwd(){

    if (this.nwpwdconfirmed!=this.nwpwd)
      this.erreurCoher = 1 ;
    else{
      let updtedata = {login: this.login , nwpwd:  sha1(this.nwpwd) } ;       
      this.erreurCoher = 0 ;

      this.remoteupdtepwd('https://admindjolof.sentelecom.com/assurance/courtier/sopandikouleiCaabi.php', updtedata).subscribe(
          retourPost => {
            if (retourPost["statutreq"]!=undefined && retourPost["statutreq"]==1 ){
              this.login = "" ;
              this.pwd = "" ;
              this.mustChangepwd = 0 ;
            }
            else
              console.log("FAILED Update") ;
      } ) ;

    }
  }

  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }

  remoteupdtepwd(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }


}
